import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.scss'

export default class ContactPhone extends PureComponent {
  static propTypes = {
    phoneNumber: PropTypes.string,
  }

  static defaultProps = {
    phoneNumber: '1300 123 455',
  }

  render() {
    const { phoneNumber } = this.props

    return (
      <div className={styles.contact}>
        <span>Customer Service</span>
        <h2 className={styles.contactHeading}><a href={`tel:${phoneNumber}`}>{phoneNumber}</a></h2>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/ContactPhone/index.jsx